import React from "react";
import Header from "../../Header/Header";
import Footer from "../../Footer/Footer";
import CommercialVehicleGlassBanner from "../../../Assets/Product_Images/CommercialVehical/CommercialVehicleGlassBanner.webp";
import Commercial_Vehicle_Glass1 from "../../../Assets/Product_Images/CommercialVehical/CommercialVehicleGlass1.jpeg";
import Commercial_Vehicle_Glass2 from "../../../Assets/Product_Images/CommercialVehical/CommercialVehicleGlass2.jpeg";
import Commercial_Vehicle_Glass3 from "../../../Assets/Product_Images/CommercialVehical/CommercialVehicleGlass3.jpeg";
import Commercial_Vehicle_Glass4 from "../../../Assets/Product_Images/CommercialVehical/CommercialVehicleGlass4.jpeg";
import Commercial_Vehicle_Glass5 from "../../../Assets/Product_Images/CommercialVehical/CommercialVehicleGlass5.jpeg";
import Commercial_Vehicle_Glass6 from "../../../Assets/Product_Images/CommercialVehical/CommercialVehicleGlass6.jpeg";
// import bend_glass_2 from "../../../Assets/AboutUs_Img/bend-glass-2.webp";
import { Link } from "react-router-dom";

const Bend_glass = () => {
  return (
    <div>
      <Header />
      {/* banner section start  */}
      <section
        className="container-fluid common_banner"
        style={{
          backgroundImage: `url(${CommercialVehicleGlassBanner})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12">
              <div className="common_title wow fadeInUp">
                <h2>
                  <Link
                    to="/AboutUs"
                    className="text-decoration-none text-white"
                  >
                    ABOUT US
                  </Link>{" "}
                  / <span className="text-white">Commercial Vehicle Glass</span>
                </h2>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* banner section end */}

      {/* about tabbing section start */}
      <section className="container-fluid about_Products_section">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12">
              <div className="blog_text wow fadeInUp">
                <h5 style={{ color: "#153fa4", fontFamily: "Segoe UI, sans-serif", fontSize: "40px", fontWeight: "700", marginBottom: "15px" }}>Commercial Vehicle Glass</h5>
                <p>
                  We specialize in manufacturing high-quality **Commercial
                  Vehicle Glass**, designed to meet the robust demands of
                  heavy-duty vehicles. Our glass products are suitable for both
                  front and side windows, ensuring superior safety, visibility,
                  and durability on the road.
                </p>
                <p>
                  Crafted using premium-grade silicon and other advanced
                  materials, each piece is engineered by our skilled
                  professionals to offer exceptional crack resistance and long
                  service life. The smooth finish and scratch-resistant
                  properties make it ideal for daily use in buses, trucks, vans,
                  and other commercial transport vehicles.
                </p>
                <p>
                  Trusted by fleet operators and OEMs alike, our commercial
                  vehicle glass is quality-tested to meet industry standards,
                  and offered at highly competitive prices to support bulk
                  orders and timely deliveries.
                </p>

                <p>
                  <strong>Key Features:</strong>
                </p>
                <ul>
                  <li>Fine and seamless finish</li>
                  <li>Scratch and crack resistance</li>
                  <li>Durable construction for commercial use</li>
                </ul>
              </div>
              <div className="Products_img gap-5 mt-5 wow fadeInUp">

                <img src={Commercial_Vehicle_Glass3} className="Commercial_Vehicle_Glass3" style={{width : "180px" , height : "180px"}} alt="car" />
                <img src={Commercial_Vehicle_Glass4} className="Commercial_Vehicle_Glass3" style={{width : "180px" , height : "180px"}} alt="car" />
                  <img src={Commercial_Vehicle_Glass1} className="Commercial_Vehicle_Glass1" style={{width : "180px" , height : "180px"}} alt="Bus" />
                <img src={Commercial_Vehicle_Glass2} className="Commercial_Vehicle_Glass2" style={{width : "180px" , height : "180px"}} alt="car" />
                <img src={Commercial_Vehicle_Glass5} className="Commercial_Vehicle_Glass3" style={{width : "180px" , height : "180px"}} alt="car" />
                <img src={Commercial_Vehicle_Glass6} className="Commercial_Vehicle_Glass3" style={{width : "180px" , height : "180px"}} alt="car" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* about tabbing section End  */}
      <Footer />
    </div>
  );
};

export default Bend_glass;
